import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/dashboard/messages";

export const Route = createFileRoute("/dashboard/messages")({
  component: Page,
});
